/* eslint-disable */
import * as types from "@/store/mutation-types";
import api from "@/service/api/venue";
import router from "@/router";

let loaderCloseTimeout = null;

function showLoader(commit) {
  if (loaderCloseTimeout) {
    clearTimeout(loaderCloseTimeout);
    loaderCloseTimeout = null;
  }
  commit("SHOW_LOADING", true);
}

function hideLoader(commit, delay = 300) {
  if (loaderCloseTimeout) {
    clearTimeout(loaderCloseTimeout);
  }
  loaderCloseTimeout = setTimeout(() => {
    commit("SHOW_LOADING", false);
    loaderCloseTimeout = null;
  }, delay);
}

// When PUT/POST persists name but slug in DB/API response stays stale, keep the slug we successfully sent until the API matches it.
const VENUE_SLUG_PREF_KEY = "vb_saved_venue_slug_v1";

function readVenueSlugPrefs() {
  try {
    const raw = localStorage.getItem(VENUE_SLUG_PREF_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (_e) {
    return {};
  }
}

function rememberVenueSlugPref(venueId, slug) {
  if (venueId == null || slug == null || String(slug).trim() === "") return;
  const prefs = readVenueSlugPrefs();
  prefs[String(venueId)] = String(slug).trim();
  localStorage.setItem(VENUE_SLUG_PREF_KEY, JSON.stringify(prefs));
}

function resolveSlugFromApiVenue(venue) {
  if (!venue) return "";
  const candidates = [venue.slug, venue.venue_slug, venue.venueSlug];
  for (let i = 0; i < candidates.length; i++) {
    const c = candidates[i];
    if (c != null && String(c).trim() !== "") return String(c).trim();
  }
  return "";
}

function applyStoredSlugPreference(venue) {
  if (!venue || venue.id == null) return venue;
  const prefs = readVenueSlugPrefs();
  const saved = prefs[String(venue.id)];
  if (saved != null && String(saved).trim() !== "") {
    return { ...venue, slug: String(saved).trim() };
  }
  return venue;
}

export default {
  createVenue({ commit }, payload) {
    const payloadFilter = JSON.parse(JSON.stringify(payload));
    if(payloadFilter.id) delete  payloadFilter.id
    showLoader(commit);
    return new Promise((resolve, reject) => {
      api
        .createVenue(payloadFilter)
        .then((response) => {
          // commit(types.SAVE_USER, { admin: response.data });
          if(response.data && response.data.venue.datajson) delete response.data.venue.datajson
          const created = response.data.venue;
          if (created && created.id != null && payloadFilter.slug != null) {
            rememberVenueSlugPref(created.id, payloadFilter.slug);
          }
          commit(types.SET_VENUE_TO_LIST, response.data.venue);
          resolve(response);
          hideLoader(commit);
        })
        .catch((error) => {
          if (error && error.response && error.response.status === 401) {
            router.push("/login");
          }

          reject(error);

          hideLoader(commit);
        });
    });
  },
  getVenues({ commit }, payload) {
   showLoader(commit);

    return new Promise((resolve, reject) => {
      api
        .getVenues(payload)
        .then((response) => {
          commit(types.SET_VENUE_LIST, response.data);
          resolve(response);

          setTimeout(() => {
            commit("SHOW_LOADING", false);
          }, 300);
        })
        .catch((error) => {
          if (error && error.response && error.response.status === 401) {
            router.push("/login");
          }

          setTimeout(() => {
            commit("SHOW_LOADING", false);
          }, 300);
          reject(error);
        });
    });
  },
  getVenue({ commit }, id) {
   showLoader(commit);

    return new Promise((resolve, reject) => {
      api
        .getVenue(id)
        .then((response) => {
          let venue = { ...response.data.venue };
          const fromApi = resolveSlugFromApiVenue(venue);
          if (fromApi) venue.slug = fromApi;
          venue = applyStoredSlugPreference(venue);
          commit(types.SET_EDIT_BUILDER_CONFIGS, venue);
          resolve(response);

          hideLoader(commit);
        })
        .catch((error) => {
          if (error && error.response && error.response.status === 401) {
            router.push("/login");
          }

          hideLoader(commit);
          reject(error);
        });
    });
  },
  updateVenue({ commit, state }, payload) {
   showLoader(commit);
    return new Promise((resolve, reject) => {
      api
        .updateVenue(payload)
        .then((response) => {
          if (payload.id != null && payload.slug != null) {
            rememberVenueSlugPref(payload.id, payload.slug);
          }
          const raw = response.data && response.data.venue;
          const current = state.edit_venue_configs;
          if (
            raw &&
            current &&
            Number(raw.id) === Number(payload.id)
          ) {
            const next = {
              ...current,
              ...raw,
              datajson:
                raw.datajson != null && raw.datajson !== undefined
                  ? raw.datajson
                  : current.datajson,
            };
            next.name = payload.name;
            next.slug = payload.slug;
            commit(types.SET_EDIT_BUILDER_CONFIGS, next);
          }
          resolve(response);

          hideLoader(commit);
        })
        .catch((error) => {
          if (error && error.response && error.response.status === 401) {
            router.push("/login");
          }

          hideLoader(commit);
          reject(error);
        });
    });
  },

  deleteVenue({ commit }, id) {
   showLoader(commit);
    return new Promise((resolve, reject) => {
      api
        .deleteVenue(id)
        .then((response) => {
          commit(types.DELETE_VENUE, id);
          resolve(response);

          hideLoader(commit);
        })
        .catch((error) => {
          if (error && error.response && error.response.status === 401) {
            router.push("/login");
          }

          reject(error);

         hideLoader(commit);
        });
    });
  },
  saveVenueConfigs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit(types.SET_VENUE, payload);
      resolve(payload);
    });
  },


  resetStoreStage({ commit }) {
    commit(types.RESET_STAGE)
  },
};
